import { List, Map } from 'immutable';
import shortid from 'shortid';

import * as constants from './../constants';

const initialState = new Map({
  browsers: {},
  recent_configs: new List(),
  saved_configs: new List(),
  url: '',
});

const addMissingId = (config) => {
  if (!config.id) {
    return new Map({ ...config, id: shortid.generate() });
  }

  return new Map(config);
};

const metadataReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case constants.METADATA_GET.SUCCESS: {
      const metadata = payload.items.reduce((result, { key, value }) => (
        { [key]: value, ...result }
      ), {});

      // Api will return { value: { url: "http://..." } } ¯\_(ツ)_/¯
      const url = (metadata.url && metadata.url.url) ? metadata.url.url : metadata.url;

      return state.merge({
        url: url || '',
        recent_configs: metadata.recent_configs ?
          new List(metadata.recent_configs.map(addMissingId)) : new List(),
        saved_configs: metadata.saved_configs ? new List(metadata.saved_configs) : new List(),
      });
    }
    case constants.OPTIONS_GET.SUCCESS:
      return state.set('browsers', payload);
    case constants.RECENT_CONFIGS_PUT.SUCCESS: {
      if (!payload.item) return state;

      let recents = new List(payload.item.value);
      recents = recents.map((config) => new Map(config));
      return state.set('recent_configs', recents);
    }
    case constants.SAVED_CONFIGS_PUT.SUCCESS: {
      if (!payload.item) return state;

      let saved = new List(payload.item.value);
      saved = saved.map((config) => new Map(config));
      return state.set('saved_configs', saved);
    }
    case constants.METADATA_PUT.SUCCESS:
      // For now we only support URL
      return (payload.url) ? state.set('url', payload.url) : state;
    default:
      return state;
  }
};

export default metadataReducer;
export { initialState };
